import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerStartEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStartEventVO.validationSchema()
  );

  constructor(readonly value: RoomMixerStartEvent) {
    JsonSchemaValidator.assert(RoomMixerStartEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomMixerStartEvent {
  roomId: RoomId;
}
